import { CircleCheck } from "lucide-react";
import { Reveal } from "./Reveal";
import copy from "@/content/homepage-copy.json";

export const FullSection = () => {
  const f = copy.full;

  return (
    <section
      id="cennik"
      className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-[88px]"
      data-testid="full-section"
    >
      <Reveal delay={0.05}>
        <div
          className="relative overflow-hidden rounded-panel border bg-brand-surface"
          style={{ borderColor: "rgba(182,255,0,0.28)" }}
        >
          <span className="pointer-events-none absolute -left-24 top-1/3 h-72 w-72 rounded-full bg-brand-accent/10 blur-3xl" aria-hidden="true" />
          <span className="pointer-events-none absolute -right-16 bottom-0 h-80 w-80 rounded-full bg-brand-accent/10 blur-3xl" aria-hidden="true" />

          <div className="relative grid grid-cols-1 gap-10 p-6 sm:p-8 lg:grid-cols-[1fr_1fr_0.62fr] lg:gap-12 lg:p-12">
            {/* LEFT: free access + price + CTA */}
            <div>
              <span
                className="inline-flex items-center rounded-full bg-brand-accent px-4 py-1.5 font-display text-[11px] font-bold uppercase tracking-[0.09em] text-brand-on"
                data-testid="full-badge"
              >
                {f.badge}
              </span>
              <h2
                className="mt-6 font-display text-4xl font-bold leading-[1.05] tracking-tight text-brand-text sm:text-5xl"
                data-testid="full-title"
              >
                {f.title}
              </h2>
              <p className="mt-4 max-w-sm text-base text-brand-sec">{f.subtitle}</p>

              <div className="my-7 h-px w-full bg-brand-line" />

              <p className="font-display text-[12px] font-bold uppercase tracking-[0.12em] text-brand-accent">
                {f.accessLabel}
              </p>
              <p className="mt-2 flex items-end gap-3">
                <span className="font-display text-6xl font-bold leading-none text-brand-text" data-testid="full-price">
                  {f.price}
                </span>
                <span className="pb-1 text-base text-brand-sec">{f.priceNote}</span>
              </p>
            </div>

            {/* CENTER: what you get free + paid note */}
            <div>
              <p className="mb-5 font-display text-[11px] font-bold uppercase tracking-[0.12em] text-brand-muted">
                {f.benefitsLabel}
              </p>
              <ul className="grid grid-cols-1 gap-4">
                {f.benefits.map((item) => (
                  <li key={item} className="flex items-center gap-3 text-[15px] text-brand-text">
                    <CircleCheck size={20} strokeWidth={1.75} className="shrink-0 text-brand-accent" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
              <div className="mt-7 rounded-card border border-brand-line bg-brand-bg/60 p-5" data-testid="full-paid-card">
                <p className="font-display text-[12px] font-bold uppercase tracking-[0.08em] text-brand-accent">
                  {f.paidTitle}
                </p>
                <p className="mt-2 text-[14px] leading-relaxed text-brand-sec">{f.paidText}</p>
              </div>
            </div>

            {/* RIGHT: credits box */}
            <div className="flex items-center justify-center">
              <div
                className="relative w-full max-w-[240px] rounded-2xl border bg-brand-bg px-6 py-8 text-center"
                style={{ borderColor: "rgba(182,255,0,0.5)", boxShadow: "0 0 40px rgba(182,255,0,0.16)" }}
                data-testid="full-box"
              >
                <div className="flex items-center justify-center gap-1.5">
                  <span className="font-display text-sm font-bold tracking-wide text-brand-text">{f.boxBrand}</span>
                  <span className="h-1.5 w-1.5 rounded-full bg-brand-accent" aria-hidden="true" />
                </div>
                <div className="mx-auto my-5 h-px w-14 bg-brand-accent/60" />
                <p className="font-display text-6xl font-bold leading-none text-brand-accent">{f.boxNumber}</p>
                <p className="mt-3 font-display text-xs font-bold uppercase tracking-[0.14em] text-brand-text">
                  {f.boxCredits}
                </p>
                <div className="mx-auto mt-6 h-px w-full bg-brand-line" />
                <p className="mt-4 font-display text-[10px] font-bold uppercase tracking-[0.14em] text-brand-muted">
                  {f.boxNote}
                </p>
              </div>
            </div>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
